import styled from 'styled-components';

import {
    Text,
} from '@zillow/constellation';

export const StyledTooltipText = styled(Text)`
    text-align: justify;
    text-justify: inter-word;
`;
